import Api from './Api';

class _ContractApi extends Api {
    loadContractList(filter: any): Promise<any> {
        return this.getHttpClient().post(`contract/list`, filter);
    }

    loadContract(data: any): Promise<any> {
        return this.getHttpClient().post(`contract/detail`, data);
    }

    loadCurrentContractTemplate(): Promise<any> {
        return this.getLocalHttpClient().get(`contracts/templates/current`);
    }

    storeContractTemplate(data: any): Promise<any> {
        return this.getLocalHttpClient().post(`contracts/templates`, data);
    }

    storeContractDetail(data: any): Promise<any> {
        return this.getHttpClient().post(`contract/detail/store`, data);
    }

    removeContract(id: number): Promise<any> {
        return this.getHttpClient().delete(`contract/${id}`);
    }

    submitContract(id: number): Promise<any> {
        return this.getHttpClient().get(`contract/send/${id}`);
    }
}

export const ContractApi = new _ContractApi();
